<template>
    <div class="container">
        <HomeHeader />
        <ReportHeader />
        <BgContainer>
            <main>
                <div class="title_row" id="move_maker">
                    <PageTitle title="搜索" :isBack="true" to="/" />
                </div>
                <!-- 搜索框 -->
                <div class="search_input">
                    <input type="text" maxlength="200" v-model.trim="query.keywords" @keyup.enter="search" placeholder="请输入搜索关键词，多个关键词空格分隔，不支持特殊符号" />
                    <button @click="search">
                        <i class="iconfont icon-sousuo"></i>
                        <span>查询</span>
                    </button>
                </div>
                <!-- 其他条件 -->
                <div class="condition">
                    <el-row>
                        <div class="row">
                            <span class="label">板块标签：</span>
                            <el-radio-group v-model="query.tagId" @change="handleTagChange">
                                <el-radio label="">全部</el-radio>
                                <el-radio v-for="item in modulars" :key="item.tagId" :label="item.tagId">{{ item.tagName }}</el-radio>
                                <!-- <el-radio label="report">报告</el-radio> -->
                            </el-radio-group>
                        </div>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="row">
                                <span class="label">板块关键词：</span>
                                <el-select style="width: 350px" multiple filterable collapse-tags clearable v-model="query.keyList" @change="search">
                                    <el-option v-for="item in modularKeywordList" :key="item" :label="item" :value="item"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="row">
                                <span class="label">来源：</span>
                                <el-select style="width: 350px" multiple filterable collapse-tags clearable v-model="query.releaseArr" @change="search">
                                    <el-option v-for="item in releaseList" :key="item" :label="item" :value="item"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="row">
                                <span class="label">国家：</span>
                                <el-select style="width: 350px" multiple filterable collapse-tags clearable v-model="query.countryArr" @change="search">
                                    <el-option v-for="item in countryDict" :key="item" :label="item" :value="item"></el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="row">
                                <span class="label">风险等级：</span>
                                <el-checkbox-group v-model="query.risk" @change="search">
                                    <el-checkbox label="high">高风险</el-checkbox>
                                    <el-checkbox label="middle">中风险</el-checkbox>
                                    <el-checkbox label="low">低风险</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="row">
                                <span class="label">发布时间：</span>
                                <DatePicker v-model:start="query.startTime" v-model:end="query.endTime" @change="search" />
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="24">
                            <div class="row">
                                <span class="label">入库时间：</span>
                                <DatePicker v-model:start="query.pullStartTime" v-model:end="query.pullEndTime" @change="search" />
                            </div>
                        </el-col>
                    </el-row>
                    <el-button class="reset" type="primary" :icon="Refresh" @click="handleReset">重置</el-button>
                </div>
                <!-- 条数及排序方式 -->
                <div class="total_sort">
                    <div class="le">
                        <div class="all">
                            <el-checkbox v-model="isAll" :indeterminate="allIndeterminate" @change="allChange">全选</el-checkbox>
                        </div>
                        <p>搜索结果 {{ total || 0 }} 条</p>
                    </div>
                    <div class="ri">
                        <div class="sort">
                            <span :class="{ active: query.sort === 1 }" @click="changeSort(1)">相关性</span>
                            <i>|</i>
                            <span :class="{ active: query.sort === 2 }" @click="changeSort(2)">发布时间</span>
                        </div>
                        <div class="btn" @click="exportExcel">
                            <i class="iconfont icon-xiazai1"></i>
                            <span>导出Excel</span>
                        </div>
                        <div class="btn" @click="openSend">
                            <i class="iconfont icon-fasongyoujian"></i>
                            <span>
                                发送报告
                                <span v-if="checkedList?.length">({{ checkedList.length }})</span>
                            </span>
                        </div>
                    </div>
                </div>
                <!-- 列表 -->
                <div class="list">
                    <ul>
                        <li v-for="item in listData" :key="item.id">
                            <div class="title">
                                <el-checkbox class="checkbox" v-model="item.checked" @click.stop @change="(e) => checkedChange(e, item)" />
                                <h1 @click="toDetails(item)" v-html="item.articleTitle"></h1>
                                <RiskChange :artcle="item" @change="(e) => (item.risk = e)">
                                    <div>
                                        <span class="risk_tag high" v-if="item.risk === 'high'">高风险</span>
                                        <span class="risk_tag middle" v-if="item.risk === 'middle'">中风险</span>
                                        <span class="risk_tag low" v-if="item.risk === 'low'">低风险</span>
                                    </div>
                                </RiskChange>
                            </div>
                            <p class="textOverflowTwo" v-html="item.description" @click="toDetails(item)"></p>
                            <div class="info">
                                <span>{{ item.tagName ? item.tagName + " | " : "" }}{{ item.articleSource }} {{ item.releaseName !== item.articleSource ? `| ${item.releaseName}` : `` }}</span>
                                <div class="ri">
                                    <span>{{ item.showTime }}</span>
                                    <div class="coll" v-if="!item.favoriteId" @click.stop="openCollDialog({ ...item })">
                                        <i class="iconfont icon-shoucang1"></i>
                                    </div>
                                    <div class="coll active" v-else @click.stop="openCancel(item)">
                                        <i class="iconfont icon-shoucang"></i>
                                    </div>
                                    <div class="coll share" @click.stop="openShare(item)">
                                        <i class="iconfont icon-fenxiang"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="arrow">
                                <ArrowRightBold class="icon" />
                            </div>
                        </li>
                    </ul>
                    <div class="page_box" v-if="total > 0">
                        <el-pagination small background layout="prev, pager, next, sizes" class="pagination" :total="total" v-model:current-page="query.pageNum" :page-sizes="[15, 30, 50, 100]" v-model:page-size="query.pageSize" @size-change="handleSizeChange" />
                    </div>
                    <el-empty description="暂无数据" v-if="!listData.length" />
                </div>
            </main>
        </BgContainer>
    </div>
    <!-- 收藏 -->
    <CollectionDialog :show="showC" :art="art" @close="closeC" @success="handleCollSuccess" />
    <!-- 分享文章 -->
    <ShareDetailsDialog :show="showShare" :row="rowShare" @close="closeShare" />
    <!-- 取消收藏 -->
    <CancelCollDialog :show="showCancel" :row="rowCancel" @close="closeCancel" @success="handleCancelSuccess" />
    <!-- 发送报告 -->
    <SendDialog :show="showSend" :groupDict="groupDict" :articleIdList="checkedList" @close="closeSend" />
</template>

<script>
export default {
    name: "Search",
};
</script>

<script setup>
import { onActivated } from "vue";
import BgContainer from "@/components/customer-week-report/pc/BgContainer.vue";
import ReportHeader from "@/components/customer-week-report/pc/ReportHeader.vue";
import PageTitle from "@/components/customer-week-report/pc/PageTitle.vue";
import { ArrowRightBold, Refresh } from "@element-plus/icons-vue";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import useData from "./useData";
import HomeHeader from "@/components/common/HomeHeader.vue";
import useKeepAlive from "@/store/useKeepAlive";
import CollectionDialog from "@/components/collection-dialog/index.vue";
import useCollectionDialog from "@/components/collection-dialog/useCollection";
import useCollection from "./useCollection";
import useDict from "./useDict";
import ShareDetailsDialog from "@/components/share-dialog/details/index.vue";
import useShareDetails from "@/components/share-dialog/details/useShareDetails";
import CancelCollDialog from "@/components/cancel-coll-dialog/index.vue";
import useCancelColl from "@/components/cancel-coll-dialog/useCancelColl";
import RiskChange from "@/components/common/RiskChange.vue";
import DatePicker from "./DatePicker.vue";
import SendDialog from "./send-dialog/index.vue";
import useSend from "./send-dialog/useSend";

const keepAliveStore = useKeepAlive(); // 缓存
const $route = useRoute();
const $router = useRouter();

// 数据
const { handleSizeChange, allChange, query, date, total, listData, handleTagChange, changeSort, search, handleReset, exportExcel, checkedList, checkedChange, getList, isAll, allIndeterminate } = useData();

// 字典
const { modulars, modularKeywordList, releaseList, countryDict, groupDict } = useDict({ query });

// 收藏弹框
const { show: showC, open: openC, close: closeC, art } = useCollectionDialog();

// 收藏
const { openCollDialog, handleCollSuccess } = useCollection({ openC, listData });

// 取消收藏
const {
    show: showCancel,
    open: openCancel,
    close: closeCancel,
    row: rowCancel,
    handleCancelSuccess,
} = useCancelColl((articleId) => {
    const obj = listData.value.find((item) => item.articleId === articleId);
    obj.favoriteId = null;
});

// 跳转详情
function toDetails(e) {
    const routeQuery = {
        ...$route.query,
        articleId: e.articleId,
        tagId1: e.tagId,
        search: "Y",
    };
    delete routeQuery.keywords;
    $router.push({
        path: `/details`,
        query: routeQuery,
    });
}

// 分享
const { show: showShare, row: rowShare, open: openShare, close: closeShare } = useShareDetails();

// 发送报告
const { show: showSend, open: openSend, close: closeSend } = useSend({ checkedList });

// 离开页面时如果时跳转详情页，缓存当前页面，如果不是跳转详情页，不缓存当前页面
onBeforeRouteLeave((to, _from, next) => {
    if (to.name === "Details") {
        keepAliveStore.setKeepRoutes(["Search"]);
    } else {
        keepAliveStore.setKeepRoutes([]);
    }
    next();
});

// 重新激活页面时刷新列表
onActivated(() => {
    getList();
});
</script>

<style lang="scss" scoped>
.container {
    background-color: #e6e6e6;
    min-height: calc(100vh - var(--home-header-height));
    padding-top: var(--home-header-height);

    .show_date {
        border-top: 1px solid var(--week-primary-color);
        position: absolute;
        top: 60px;
        right: 44px;
        padding-top: 30px;
        padding-right: 100px;
        padding-left: 10px;
        display: flex;
        align-items: center;
    }

    .small_logo {
        position: absolute;
        top: 87px;
        right: 52px;
    }

    main {
        width: 100%;
        min-height: calc(100vh - var(--week-pc-header-height));
        background-color: #f5f5f5;
        box-shadow: 0 0 20px #ccc;
        padding: 46px 80px;

        .title_row {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .search_input {
            margin-top: 30px;
            display: flex;
            input {
                flex: 1;
                height: 48px;
                border: 1px solid #afafaf;
                border-right: none;
                padding: 0 16px;
                background: none;
                font-size: 16px;
                &:focus {
                    border-color: var(--primary-color);
                }
            }
            button {
                width: 160px;
                height: 48px;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: var(--primary-color);
                .iconfont {
                    color: #fff;
                    font-size: 20px;
                }
                span {
                    color: #fff;
                    font-size: 16px;
                    padding-left: 8px;
                }
            }
        }
        .condition {
            padding-top: 44px;
            position: relative;
            .el-row {
                margin-bottom: 12px;
            }
            .row {
                display: flex;
                align-items: center;
                min-height: 32px;
                margin-bottom: 12px;
                &:last-child {
                    margin-bottom: 0;
                }
                .label {
                    width: 96px;
                    color: #727272;
                    font-size: 14px;
                }
                :deep(.el-input__inner) {
                    border-radius: 2px;
                }
                :deep(.el-radio) {
                    margin-right: 10px;
                }
            }
            .reset {
                position: absolute;
                bottom: 0;
                right: 0;
                border-radius: 2px;
            }
        }

        .total_sort {
            margin-top: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .le {
                display: flex;
                align-items: center;
                p {
                    font-size: 14px;
                    color: #2a2a2a;
                    margin-left: 30px;
                    line-height: 1em;
                }
            }
            .ri {
                display: flex;
                align-items: center;
                .sort {
                    display: flex;
                    align-items: center;
                    span,
                    i {
                        margin-left: 14px;
                        color: #727272;
                    }
                    span {
                        cursor: pointer;
                        &.active {
                            color: var(--primary-color);
                        }
                    }
                }
                .btn {
                    display: flex;
                    align-items: center;
                    color: var(--primary-color);
                    margin-left: 20px;
                    user-select: none;
                    cursor: pointer;
                    .iconfont {
                        margin-right: 4px;
                    }
                }
            }
        }

        .list {
            min-height: 800px;
            background-color: #fff;
            flex: 1;
            box-shadow: 2.7px 7.5px 8.19px 0.81px rgba(0, 0, 0, 0.06);
            padding: 0 46px;
            padding-bottom: 33px;
            margin-top: 16px;

            ul {
                padding-bottom: 50px;

                li {
                    padding-top: 35px;
                    padding-bottom: 24px;
                    border-bottom: 1px solid #cecece;
                    position: relative;
                    padding-right: 54px;
                    .title {
                        display: flex;
                        flex-wrap: wrap;
                        position: relative;
                        h1 {
                            font-size: 16px;
                            color: #000;
                            font-family: "SourceHanSansCN-Normal-Alphabetic";
                            cursor: pointer;
                            :deep(span) {
                                color: var(--primary-color);
                                font-size: inherit;
                            }
                        }
                        .risk_tag {
                            display: inline-block;
                            height: 16px;
                            line-height: 16px;
                            display: flex;
                            align-items: center;
                            background-color: #ccc;
                            border-radius: 8px;
                            color: #fff;
                            font-size: 12px;
                            padding: 0 8px;
                            margin-top: 4px;
                            margin-left: 4px;
                            cursor: pointer;
                            &.high {
                                background-color: #ff2f00;
                            }
                            &.middle {
                                background-color: #ff8000;
                            }
                            &.low {
                                background-color: #43cf7c;
                            }
                        }
                        .checkbox {
                            position: absolute;
                            left: -22px;
                            top: -3px;
                        }
                    }
                    p {
                        color: #727272;
                        font-size: 12px;
                        margin-top: 20px;
                        line-height: 1.8em;
                        :deep(span) {
                            color: var(--primary-color);
                            font-size: inherit;
                        }
                    }

                    .info {
                        display: flex;
                        justify-content: space-between;
                        padding-top: 11px;

                        span {
                            font-size: 12px;
                            color: #999;
                        }
                        .ri {
                            display: flex;
                            align-items: center;
                            .coll {
                                margin-left: 16px;
                                cursor: pointer;
                                .iconfont {
                                    color: #999;
                                    font-size: 18px;
                                }
                                &.active {
                                    .iconfont {
                                        color: var(--primary-color);
                                    }
                                }
                            }
                        }
                    }

                    .arrow {
                        width: 18px;
                        height: 18px;
                        background-color: var(--week-primary-color);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        position: absolute;
                        top: 37px;
                        right: 0;

                        .icon {
                            width: 1em;
                            height: 1em;
                            color: #fff;
                        }
                    }

                    &:hover {
                        h1 {
                            text-decoration: underline;
                        }
                    }
                }
            }

            .page_box {
                display: flex;
                align-items: center;
                justify-content: center;

                :deep(.el-pagination .el-pager li) {
                    border-radius: 50%;
                    background-color: #cbcbcb;
                    color: #fff;
                    margin: 0 5px;
                }

                // 上下一页样式修改
                :deep(.el-pagination .btn-prev),
                :deep(.el-pagination .btn-next) {
                    background-color: #cbcbcb;
                    color: #fff;
                }

                // 上下一页不可点时，hover字体颜色修改
                :deep(.el-pagination .btn-prev:not(:disabled):hover),
                :deep(.el-pagination .btn-next:not(:disabled):hover) {
                    color: var(--week-primary-color);
                }

                :deep(.el-pagination.is-background .el-pager li:not(.disabled).active) {
                    background-color: var(--week-primary-color);
                }

                :deep(.el-pagination.is-background .el-pager li:not(.active):hover) {
                    color: var(--week-primary-color);
                }

                :deep(.btn-quicknext) {
                    display: inline-flex;
                    align-items: center;
                }
                // :deep(.el-pagination__sizes) {
                // }
            }
        }
    }
}
</style>
